module.exports = __webpack_public_path__ + "img/2021-OAW-01-986x310.79a1ee1e.png";